import React from 'react';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  TablePagination,
  Box,
} from '@material-ui/core';
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function UserTable({
  users,
  page,
  rowsPerPage,
  anchorEl,
  selectedUserId,
  onPageChange,
  onRowsPerPageChange,
  onMenuClick,
  onMenuClose,
  onEdit,
  onDelete,
  getRoleChipColor,
  getRoleLabel,
}) {
  //ocultar del listado de usuarios al usuario con email @tcit.cl
  let finalUsers = users.filter((u) => !u.email || !u.email.endsWith('@tcit.cl')); 
  //si el usuario logeado tiene email @tcit.cl mostrar todos los usuarios
  const user = useSelector((state) => state);
  if(user.app.user.email.endsWith('@tcit.cl')){
    finalUsers = users;
  }
  const { t } = useTranslation();
  const displayValue = (value) =>
    value && value.trim() !== '' ? (
      value
    ) : (
      <span style={{ textAlign: 'center', display: 'block', color: '#999' }}>-</span>
    );

  return (
    <Card>
      <TableContainer>
        <Table style={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow style={{ height: '56px' }}>
              <TableCell style={{ width: '8%' }}>ID</TableCell>
              <TableCell style={{ width: '25%' }}>{t('Full name')}</TableCell>
              <TableCell style={{ width: '22%' }}>{t('Email')}</TableCell>
              <TableCell style={{ width: '15%' }}>{t('Phone')}</TableCell>
              <TableCell style={{ width: '12%' }}>{t('Role')}</TableCell>
              <TableCell style={{ width: '18%' }}>{t('Position')}</TableCell>
              <TableCell style={{ width: '10%' }}>{t('Actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {finalUsers.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} style={{ textAlign: 'center', padding: '40px' }}>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <Typography variant="h6" color="textSecondary">
                      {t('No users to show')}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t('Add first user message')}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              finalUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
                <TableRow
                  key={user.id}
                  hover
                  style={{ height: '64px' }} // Altura fija para todas las filas
                >
                  <TableCell>#{user.id}</TableCell>
                  <TableCell>{displayValue(user.full_name)}</TableCell>
                  <TableCell>
                    {user.email && user.email.trim() !== '' ? (
                      <Typography
                        component="a"
                        href={`mailto:${user.email}`}
                        color="primary"
                        style={{ textDecoration: 'none' }}>
                        {user.email}
                      </Typography>
                    ) : (
                      <span style={{ textAlign: 'center', display: 'block', color: '#999' }}>
                        -
                      </span>
                    )}
                  </TableCell>
                  <TableCell>{displayValue(user.phone)}</TableCell>
                  <TableCell>
                    {user.role && user.role.name ? (
                      <Chip
                        label={getRoleLabel(user.role.name)}
                        color={getRoleChipColor(user.role.name)}
                        size="small"
                      />
                    ) : (
                      <span style={{ textAlign: 'center', display: 'block', color: '#999' }}>
                        -
                      </span>
                    )}
                  </TableCell>
                  <TableCell>{displayValue(user.position)}</TableCell>
                  <TableCell align="center">
                    <IconButton size="small" onClick={(e) => onMenuClick(e, user.id)}>
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginación */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={finalUsers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        labelRowsPerPage={t('Rows per page')}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t('of')} ${count}`}
        backIconButtonText={t('Previous page')}
        nextIconButtonText={t('Next page')}
      />

      {/* Menú de acciones */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onMenuClose}>
        <MenuItem onClick={onEdit}>
          <EditIcon style={{ marginRight: 8 }} />
          {t('Edit')}
        </MenuItem>
        <MenuItem onClick={onDelete}>
          <DeleteIcon style={{ marginRight: 8 }} />
          {t('Delete')}
        </MenuItem>
      </Menu>
    </Card>
  );
}

export default UserTable;
